import styled from "styled-components";

export const GamificationModalContainerStyled = styled.div`
  background-color: ${({ theme }) => theme.store.productModalBackground};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.console.sidebar.borderColor};

  padding: 1.875rem;

  width: 464.5px;

  @media (max-width: 500px) {
    border-radius: 24px 24px 0px 0px;

    width: 100%;

    position: relative;
    bottom: -5px;
  }
`;
